import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

import getConst from "api/common/getConst";

import lang from "lang";

const App = React.lazy(() => import("./App"));
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <Suspense
        fallback={
            <div
                style={{
                    height: "100dvh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    backgroundColor: "#fff",
                }}
            >
                <div style={{ textAlign: "center" }}>
                    <img
                        src={getConst("assets-images-path") + "load.webp"}
                        alt="loader"
                        width={200}
                        height={200}
                    />
                    <div
                        style={{
                            margin: 0,
                            fontFamily: `"core", sans-serif`,
                            fontWeight: "300",
                            fontSize: "1.25rem",
                            lineHeight: 1.6,
                            color: "rgba(0, 0, 0, 0.6)",
                        }}
                    >
                        {lang.components.loader.firstText}
                    </div>
                </div>
            </div>
        }
    >
        <App />
    </Suspense>
);
